/**
 * To get an encoded string
 * Avoids encodeURIComponent as we need commas to stay unencoded. Anything else can be encoded.
 * DO NOT do `encodeURIComponent(value).replace(/%2C/g, ","):` as _some_ commas need to be encoded:
 * @param {string} value
 * @returns {string} a encoded string
 */
export const encodeSearchValue = value =>
  encodeURI(value)
    .replace(/&/g, '%26')
    .replace(/#/g, '%23')
    .replace(/\+/g, '%2b');

/**
 * To get an encoded string query string
 * @param {object} params
 * @param {boolean} isEncoded
 * @returns {string}
 */
export const makeSearchQueryString = (params, isEncoded) =>
  Object.keys(params)
    .filter(key => params[key] != null)
    .map(
      param =>
        `${encodeURIComponent(param)}=${
          isEncoded ? params[param] : encodeSearchValue(params[param])
        }`,
    )
    .join('&');

/**
 * @param {string} passedUri:eg. /webapi/xm/1/people
 * @param {object} params
 * @param {boolean} isEncoded
 * @returns {string} a url with encoded params eg /webapi/xm/1/people?limit=100&offset=0&embed=roles,permittedActions
 */
export const getListingURIGenerator = (passedUri, params, isEncoded = false) =>
  params
    ? `${passedUri}?${makeSearchQueryString(params, isEncoded)}`
    : passedUri;
